import { Box, Divider, NotificationCounter, NotificationCounterVariant } from '@televet/kibble-ui';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { Icon } from '@televet/kibble-ui/build/components/Icon';
import React from 'react';
import { TaskStatus } from 'shared/types/graphql';

type TaskStatusButtonProps = {
  status?: TaskStatus;
  disabled?: boolean;
  showBadge?: boolean;
};

const getStatusLabelAndColor = (
  status?: TaskStatus,
): {
  background: string;
  text: string;
} => {
  switch (status) {
    case TaskStatus.Open:
      return {
        background: 'background.primary',
        text: 'New',
      };
    case TaskStatus.InProgress:
      return {
        background: 'text.warning',
        text: 'In Progress',
      };
    case TaskStatus.Completed:
      return {
        background: 'background.secondary',
        text: 'Completed',
      };
    default:
      return {
        background: '',
        text: '',
      };
  }
};

const TaskStatusMenuButton = ({ status, disabled, showBadge }: TaskStatusButtonProps): JSX.Element => {
  const { background, text } = getStatusLabelAndColor(status);

  return (
    <Box position="relative">
      {!disabled && (
        <Divider
          width="1px"
          height="100%"
          orientation="vertical"
          backgroundColor="whiteAlpha.500"
          m={0}
          p={0}
          borderLeftWidth={0}
          position="absolute"
          right="22px"
          zIndex={1}
          cursor="pointer"
        />
      )}
      <Button
        size="xs"
        backgroundColor={background}
        _hover={{ bg: background }}
        _active={{ bg: background }}
        _focus={{ bg: background }}
        cursor={!disabled ? undefined : 'initial'}
        rightIcon={
          !disabled ? (
            <Icon
              pb={1}
              transform="rotate(90deg)"
              css={`
                path {
                  fill: white !important;
                }
              `}
              fill="white"
              name="caretUp"
              size="xs"
            />
          ) : undefined
        }
      >
        {text}
      </Button>
      {showBadge && status === TaskStatus.Open && (
        <NotificationCounter
          size="xs"
          variant={NotificationCounterVariant.Red}
          position="absolute"
          top="-4px"
          right="-4px"
        />
      )}
    </Box>
  );
};

export default TaskStatusMenuButton;
